import { useState } from "react";
import useUnsuspendedTranslation from "../hooks/useUnsuspendedTranslation";
import Error from "./Error";
import ErrorModal from "./ErrorModal";
import ForceRefreshToken from '../ForceRefreshToken'

const ErrorDisplay = ({ error }) => {
  const { t } = useUnsuspendedTranslation();
  const [show] = useState(true);
  const isNubError = (error?.response?.config?.url || '').match('/nubs.json')
  switch (error?.response?.status) {
    case 401:
      return <ForceRefreshToken />;
    case 403:
      return (
        <Error
          title={t("Not Authorized")}
          message={t("You need to be a game administrator in order to take that action.")}
        />
      );
    case 404:
      return (
        <Error
          title={t("Not Found")}
          message={t("You need to be a game administrator in order to take that action.")}
        />
      );
    case 406:
    case 500:
    case 501:
    case 502:
    case 503:
      const description = {
        406: t(`<strong>Error 406</strong>: <em>The browser has requested a response using Accept- headers that the server cannot fulfill.</em>`),
        500: t(`<strong>Error 500</strong>: <em>The server encountered an unexpected condition that prevented it from fulfilling the request.</em>`),
        501: t(`<strong>Error 501</strong>: <em>The server does not support the functionality required to fulfill the request.</em>`),
        502: 
            // show specific error for AI nubs creation
            isNubError
                ? t(`<em>You're only able to create ${process.env.REACT_APP_MAX_AI_PER_HOUR} AI generated photos in an hour. Please wait and try again later.</em>`)  
                : t(`<strong>Error 502</strong>: <em>The server, while acting as a gateway or proxy, received an invalid response from the upstream server.</em>`),
        503: t(`<strong>Error 503</strong>: <em>The server is not ready to handle the request.</em>`),
      }
      const title = {
        501: t(`Server error`),
        502: isNubError ? t(`Limit Reached`) : t(`Server error`),
        503: t(`Server error`),
      }
      return (
        <ErrorModal
          title={title[error?.response?.status] || t("Lost connection")}
          message={(
            <>
                {
                error?.response?.status === 500 
                    ? <p className="mb-4">{t(`There has been a problem connecting with our platform. Please click retry to try again.`)}</p>
                    : null
                }
                <p dangerouslySetInnerHTML={{__html: description[error?.response?.status]}} />
            </>
          )}
          onConfirm={() => window.location.reload(true)}
          onDismiss={() => window.location.reload(true)}
          show={show}
        />
      );
    default:
      return (
        <Error
          title={t("An error occurred.")}
          message={t("Builder is experiencing an unknown error.")}
        />
      );
  }
};

export default ErrorDisplay;
